import {
  type CreateTripTypeRequest,
  type TripTypeDetail,
  TripTypeDetailSchema,
  type TripTypeListQuery,
  type TripTypeListResponse,
  TripTypeListResponseSchema,
  type UpdateTripTypeRequest,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

/**
 * TripType master API. Every response is validated with the shared Zod
 * schema so a server change can't sneak past the UI types.
 */

export const listTripTypes = async (query: TripTypeListQuery): Promise<TripTypeListResponse> => {
  const { data } = await apiClient.get<unknown>('/trip-types', { params: query });
  return TripTypeListResponseSchema.parse(data);
};

export const getTripType = async (id: string): Promise<TripTypeDetail> => {
  const { data } = await apiClient.get<unknown>(`/trip-types/${id}`);
  return TripTypeDetailSchema.parse(data);
};

export const createTripType = async (payload: CreateTripTypeRequest): Promise<TripTypeDetail> => {
  const { data } = await apiClient.post<unknown>('/trip-types', payload);
  return TripTypeDetailSchema.parse(data);
};

export const updateTripType = async (
  id: string,
  payload: UpdateTripTypeRequest,
): Promise<TripTypeDetail> => {
  const { data } = await apiClient.patch<unknown>(`/trip-types/${id}`, payload);
  return TripTypeDetailSchema.parse(data);
};

export const deleteTripType = async (id: string): Promise<void> => {
  await apiClient.delete(`/trip-types/${id}`);
};
